// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Date$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as PpSubscriptionStatus from "../../../../app/premium-partner/entity/PpSubscriptionStatus.bs.js";

function getStatusCell(status) {
  if (status) {
    return {
            TAG: /* Status */2,
            color: /* StatusRed */1,
            text: PpSubscriptionStatus.toString(status)
          };
  } else {
    return {
            TAG: /* Status */2,
            color: /* DarkGreen */0,
            text: PpSubscriptionStatus.toString(status)
          };
  }
}

function getExpiryDateCell(expiry_date) {
  return {
          TAG: /* Custom */5,
          _0: (function (param) {
              if (expiry_date !== undefined) {
                return Date$Catalyst.toString("DD/MM/YY", Caml_option.valFromOption(expiry_date));
              } else {
                return "NA";
              }
            })
        };
}

function getCardSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Start Date"
            },
            accessor: (function (param) {
                return {
                        TAG: /* Date */1,
                        format: "DD/MM/YY",
                        date: param.start_date
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Status"
              },
              accessor: (function (param) {
                  return getStatusCell(param.status);
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Expiry Date"
                },
                accessor: (function (param) {
                    return getExpiryDateCell(param.expiry_date);
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function getListSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Name"
            },
            accessor: (function (param) {
                return {
                        TAG: /* Text */0,
                        _0: param.scheme_name
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Start Date"
              },
              accessor: (function (param) {
                  return {
                          TAG: /* Date */1,
                          format: "DD/MM/YY",
                          date: param.start_date
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "End Date"
                },
                accessor: (function (param) {
                    return {
                            TAG: /* Date */1,
                            format: "DD/MM/YY",
                            date: param.end_date
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Status"
                  },
                  accessor: (function (param) {
                      return getStatusCell(param.status);
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Expiry Date"
                    },
                    accessor: (function (param) {
                        return getExpiryDateCell(param.expiry_date);
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Expiry Reason"
                      },
                      accessor: (function (param) {
                          return {
                                  TAG: /* Text */0,
                                  _0: Belt_Option.getWithDefault(param.expiry_reason, "NA")
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Price"
                        },
                        accessor: (function (param) {
                            var subscription_price = param.subscription_price;
                            return {
                                    TAG: /* Custom */5,
                                    _0: (function (param) {
                                        if (subscription_price !== undefined) {
                                          return String(subscription_price);
                                        } else {
                                          return "NA";
                                        }
                                      })
                                  };
                          })
                      },
                      tl: {
                        hd: {
                          column: {
                            TAG: /* Text */0,
                            _0: "Payment Ref No"
                          },
                          accessor: (function (param) {
                              return {
                                      TAG: /* Text */0,
                                      _0: Belt_Option.getWithDefault(param.payment_reference_number, "NA")
                                    };
                            })
                        },
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

export {
  getListSchema ,
  getCardSchema ,
  
}
/* Date-Catalyst Not a pure module */
